import style from './style.styl'

const Template = ({ title, copy, button, image, skipLiveChatImage = false }) => {
  if (!image && !skipLiveChatImage) {
    image = <img style={{ width: "100%" }} src={ require('images/gifs/live-chat.gif') } />
  }

  return (
    <div style={{ height: "100vh", width: "100vw" }} className="flex-column flex-space-between">
      <div className={ `${style.Content} flex-column flex-space-between` }>
        <img style={{ width: 123, height: 50 }} src={ require('images/svg/drift-logo-with-name.svg') } />
        <div className="dsg-medium-weight dsg-h3">
          { title }
        </div>
        <div>
          { copy }
        </div>
        <div className="flex-column" style={{ minHeight: 80 }}>
          { button }
        </div>
      </div>
      { image }
    </div>
  )
}

export default Template



// WEBPACK FOOTER //
// ./src/scripts/components/MobileLander/Template.js